import { render, staticRenderFns } from "./VersionHint.vue?vue&type=template&id=3018dfac"
import script from "./VersionHint.vue?vue&type=script&lang=js"
export * from "./VersionHint.vue?vue&type=script&lang=js"
import style0 from "./VersionHint.vue?vue&type=style&index=0&id=3018dfac&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports